module.exports = "<div class=\"editor-unavailable\">\n  <div><i class=\"fas fa-4x fa-ban\" data-fa-transform=\"flip-h\"></i></div>\n  <div class=\"editor-unavailable-message\">Editor Unavailable for {{customer.name}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/editor/editor-unavailable/editor-unavailable.component.html
// module id = ./src/app/editor/editor-unavailable/editor-unavailable.component.html
// module chunks = main